export var ETranslationType;
(function (ETranslationType) {
    ETranslationType["ADDON"] = "addon";
    ETranslationType["OFFER"] = "offer";
    ETranslationType["PORTFOLIO_PROJECT"] = "portfolio_project";
    ETranslationType["VILLAGE_PROJECT"] = "village";
})(ETranslationType || (ETranslationType = {}));
